import React, { useState, useEffect } from 'react';
import { motion } from "framer-motion";
import sheep1 from "../../assets/sheep1.png";
import sheep2 from "../../assets/sheep2.png";
import sheep3 from "../../assets/sheep3.png";
import sheep4 from "../../assets/sheep4.png";
import companionRam from "../../assets/companion_ram.png";
import shephard from "../../assets/shepard.png";
import './SheepsAndShepard.scss';

type Props = {
  weightedNumber: number;
  totalYGY: number;
}

type StyleProp = {
  left?: string;
  right?: string;
}

type SheepProps = {
  side: string;
  style: StyleProp;
  sheepCount: number;
}

type MotionSheepProp = {
  sheep: string;
  alt: string;
  x: number[];
  y: number[];
  duration: number;
}

function SheepMotionImage({ sheep, alt, x, y, duration }: MotionSheepProp) {
  return (
    <motion.img
      animate={{ x: x, y: y}}
      src={sheep}
      alt={alt}
      transition={{
        loop: Infinity,
        ease: "linear",
        duration,
      }}
      // animate={{ scaleX: -1 }}
      // transition={{ from: 1, duration: 2, loop: Infinity }}
    ></motion.img>
  )
}


function Sheeps({ side, style, sheepCount }: SheepProps) {

  function randomInteger(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function getValues() {
    return [0, randomInteger(10, 30), 0];
  }

  return (
    <div className={side} style={style}>
      <div className="positioner">
        <div className="upper-sheeps">
          {sheepCount >= 3 && <SheepMotionImage sheep={sheep1} alt="sheep" x={getValues()} y={[0,0]} duration={randomInteger(8, 15)} />}
          {sheepCount >= 4 && <SheepMotionImage sheep={sheep2} alt="sheep" x={getValues()} y={getValues()} duration={randomInteger(8, 15)} />}
        </div>
        <div className="middle-sheeps">
          {sheepCount >= 1 && <SheepMotionImage sheep={sheep3} alt="sheep" x={[0, 0]} y={getValues()} duration={randomInteger(8, 15)} />}
          {sheepCount >= 6 && <SheepMotionImage sheep={companionRam} alt="companion-ram" x={getValues()} y={[0,0]} duration={randomInteger(8, 15)} />}
          {sheepCount >= 5 && <SheepMotionImage sheep={shephard} alt="shephard" x={getValues()} y={getValues()} duration={randomInteger(8, 15)} />}
        </div>
        <div className="lower-sheeps">
          {sheepCount >= 2 && <SheepMotionImage sheep={sheep4} alt="sheep" x={getValues()} y={getValues()} duration={randomInteger(8, 15)} />}
        </div>
      </div>
    </div>
  )
}

function SheepsAndShepard({ weightedNumber, totalYGY }: Props) {
  const [width, setWidth] = useState(window.innerWidth);

  const updateWindowDimensions = () => {
    setWidth(window.innerWidth)
  }

  const sheepsLeftCounter = () => {
    switch(weightedNumber) {
      case 1: return 1;
      case 2: return 2;
      case 3: return 2;
      case 4: return 3;
      case 5: return 3;
      case 6: return 4;
      case 7: return 5;
      case 8: return 6;
      default: return 1;
    }
  }

  const sheepsRightCounter = () => {
    if (totalYGY <= 125) { return 1 };
    if (totalYGY <= 375) { return 2 };
    if (totalYGY <= 625) { return 3 };
    if (totalYGY <= 750) { return 4 };
    if (totalYGY <= 875) { return 5 };
    if (totalYGY <= 1000) { return 6 };
    return 6;
  }

  useEffect(() => {
    window.addEventListener('resize', updateWindowDimensions);
    return () => {
      window.removeEventListener('resize', updateWindowDimensions)
    }
  }, [])

  return (
    <div className="sheeps-container">
      <div className="sheeps-wrapper">
        <Sheeps
          side="sheeps-left"
          style={{ right: `calc(${width}px - 38%)` }}
          sheepCount={sheepsLeftCounter()}
        />
        <Sheeps
          side="sheeps-right"
          style={{ left: `calc(${width}px - 38%)` }}
          sheepCount={sheepsRightCounter()}
        />
      </div>
    </div>
  );
}

export default SheepsAndShepard;